import React from "react";

const NavInfoGeneral = ({ title, text }) => {
    return (
        <>
            <div className="semester-nav-info">
                <div className="side-nav-info-header">
                    { title }
                </div>
                <div className="text-side-nav">
                    { text }
                </div>
            </div>
        </>
    );
}

export default NavInfoGeneral;